import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { ReactComponent as Location } from "../../../../../assets/svg/location.svg";
import { IBranch } from "../../../types";

interface ExpandedBranch {
  branches: IBranch[];
}

const useStyles = makeStyles(() => ({
  branch: {
    display: "grid",
    fontSize: 12,
    wordBreak: "break-word",
    gridTemplateColumns: "20px auto",
    "& + &": {
      marginTop: 10,
    },
  },
  icon: {
    marginTop: 2,
  },
}));

export const ExpandedBranch: FC<ExpandedBranch> = ({ branches }) => {
  const classes = useStyles();

  return (
    <div>
      {branches.map((branch) => (
        <div key={branch.branchId} className={classes.branch}>
          <Location className={classes.icon} />
          {branch.name}
        </div>
      ))}
    </div>
  );
};
